import React from 'react';
import PropTypes from 'prop-types';

const ArrowSwitchVertical = ({ color = 'currentColor', ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.43945 2.46191L8.12695 0.774414M8.12695 0.774414L9.81445 2.46191M8.12695 0.774414L8.12695 9.77441M4.18945 8.08691L2.50195 9.77441M2.50195 9.77441L0.814453 8.08691M2.50195 9.77441L2.50195 0.774414"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ArrowSwitchVertical.propTypes = {
  color: PropTypes.string,
};

export default ArrowSwitchVertical;
